import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCupHot: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCupHot"><Path d="M4.5 7.5H17.5V21.5H4.5V7.5Z" stroke="currentColor"/><Path d="M17.5 9.5H18.5C20.1569 9.5 21.5 10.8431 21.5 12.5C21.5 14.1569 20.1569 15.5 18.5 15.5H17.5V9.5Z" stroke="currentColor"/><Path d="M10.5 5.5V2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 5.5V2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 5.5V2.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCupHot;
